<template>
  <div class="closure-agreement">
    <attributes-list
      :model="model"
      :source="source.road_block"
      :related="related"
      is-editing
      @hasChanges="$emit('hasChanges')"
    />
  </div>
</template>

<script>
import attributesList from '@/components/globals/r-modal-elements/attributes-list'

export default {
  components: {
    attributesList
  },
  props: {
    model: {
      type: Array,
      required: true
    },
    source: {
      type: Object,
      required: true
    },
    related: {
      type: Object,
      required: true
    }
  }
}
</script>
